module.exports = __webpack_public_path__ + "static/media/logo(en).256b81df.svg";